import { StyledPremiumBadge } from './StyledPremiumBadge';

export default StyledPremiumBadge;
